import _ from 'lodash';
import Vue from 'vue';

export default {
  add_pending_request (state, requestInfo) {
    state.pendingRequests[requestInfo.requestKey] = requestInfo.cancelHandler;
  },

  add_request_panel_callback (state, callbackInfo) {
    const { route, event, callback } = callbackInfo;
    if (route && event && _.isFunction(callback)) {
      _.set(state.requestPanelCallbacks, [ route, event, callback.name ], callback);
    }
  },

  add_ws_update_callback (state, callbackInfo) {
    const { name, callback } = callbackInfo;
    if (name && _.isFunction(callback)) {
      _.set(state.wsUpdateCallbacks, name, callback);
    }
  },

  del_pending_request (state, requestKey) {
    delete state.pendingRequests[requestKey];
  },

  clear_app_state (state) {
    state.appState = '';
  },

  close_panels (state) {
    state.sidePanels.splice(0);
  },

  remove_request_panel_callback (state, callbackInfo) {
    const { route, event, callback } = callbackInfo;
    if (route && event && _.isFunction(callback)) {
      _.unset(state.requestPanelCallbacks, [ route, event, callback.name ]);
    }
  },

  remove_ws_update_callback (state, name) {
    if (name) {
      _.unset(state.wsUpdateCallbacks, name);
    }
  },

  set_app_state (state, appState) {
    state.appState = appState;
  },

  update_panel_open_status (state) {
    state.sidePanelOpened = state.sidePanels.length > 0;
  },

  show_panel (state, panel) {
    state.sidePanels.push(panel);
  },

  mark_unsaved_changes (state, vueComponent) {
    // Use the auto-generated tag as unique identifier for the specified vueComponent.
    let key = vueComponent.$vnode.tag;
    // See change detection caveats for object: https://vuejs.org/v2/guide/reactivity.html#For-Objects
    Vue.set(state.unsavedChanges, key, true);
  },

  unmark_all_unsaved_changes (state) {
    // See change detection caveats for object: https://vuejs.org/v2/guide/reactivity.html#For-Objects
    for (let key in state.unsavedChanges) {
      Vue.delete(state.unsavedChanges, key);
    }
  },

  unmark_unsaved_changes (state, vueComponent) {
    let key = vueComponent.$vnode.tag;
    // See change detection caveats for object: https://vuejs.org/v2/guide/reactivity.html#For-Objects
    Vue.set(state.unsavedChanges, key, false);
  },

  clear_selected_user (state) {
    state.selectedUser = null;
  },

  set_selected_user (state, user) {
    state.selectedUser = user;
  }
};
